import { alpha } from "@mui/material";

export default {
	defaultProps: {
		disableTouchRipple: true,
		disableRipple: true,
	},
	styleOverrides: {
		root: ({ theme }) => ({
			boxSizing: 'border-box',
			transition: 'all 100ms ease-in',
			'&:focus-visible': {
				outline: `3px solid ${alpha(theme.palette.primary.main, 0.5)}`,
				outlineOffset: '2px',
			},
		}),
	},
}
